import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { createSelector } from 'reselect'
import { networthSummaryAmountSelector } from 'selectors/networthSelectors'
import NetworthAmount from 'components/features/pfm/NetworthAmount/NetworthAmount'
import { networthSummaryAmountGuard } from 'guards/networthGuards'

const createMapStateToProps = () => createSelector(
  networthSummaryAmountSelector,
  (amount) => {
    return {
      amount,
    }
  }
)

const guards: Guards = [
  networthSummaryAmountGuard,
]

const NetworthAmountContainer = connectShadedLoadable<
  // TODO
  {}, {}, {}, {}
>(createMapStateToProps, undefined, guards)(NetworthAmount)

export default NetworthAmountContainer
